import type { SupportedLocale } from './config';

// Static language names for each active UI locale.
export const LANGUAGE_OPTION_COPY = {
  en: {
    en: 'English',
    ar: 'Arabic',
    es: 'Spanish',
    'pt-BR': 'Portuguese (Brazil)',
    fr: 'French',
    it: 'Italian',
    ko: 'Korean',
    de: 'German',
    ja: 'Japanese',
    hi: 'Hindi',
    ru: 'Russian',
    zh: 'Chinese',
    'zh-TW': 'Traditional Chinese',
    vi: 'Vietnamese',
    id: 'Indonesian',
  },
  ar: {
    en: 'الإنجليزية',
    ar: 'العربية',
    es: 'الإسبانية',
    'pt-BR': 'البرتغالية (البرازيل)',
    fr: 'الفرنسية',
    it: 'الإيطالية',
    ko: 'الكورية',
    de: 'الألمانية',
    ja: 'اليابانية',
    hi: 'الهندية',
    ru: 'الروسية',
    zh: 'الصينية',
    'zh-TW': 'الصينية (التقليدية)',
    vi: 'الفيتنامية',
    id: 'الإندونيسية',
  },
  es: {
    en: 'inglés',
    ar: 'árabe',
    es: 'Español',
    'pt-BR': 'portugués (Brasil)',
    fr: 'francés',
    it: 'italiano',
    ko: 'coreano',
    de: 'alemán',
    ja: 'japonés',
    hi: 'hindi',
    ru: 'ruso',
    zh: 'chino',
    'zh-TW': 'chino (tradicional)',
    vi: 'vietnamita',
    id: 'indonesio',
  },
  'pt-BR': {
    en: 'inglês',
    ar: 'árabe',
    es: 'espanhol',
    'pt-BR': 'Português (Brasil)',
    fr: 'francês',
    it: 'italiano',
    ko: 'coreano',
    de: 'alemão',
    ja: 'japonês',
    hi: 'hindi',
    ru: 'russo',
    zh: 'chinês',
    'zh-TW': 'chinês (tradicional)',
    vi: 'vietnamita',
    id: 'indonésio',
  },
  fr: {
    en: 'anglais',
    ar: 'arabe',
    es: 'espagnol',
    'pt-BR': 'portugais (Brésil)',
    fr: 'Français',
    it: 'italien',
    ko: 'coréen',
    de: 'allemand',
    ja: 'japonais',
    hi: 'hindi',
    ru: 'russe',
    zh: 'chinois',
    'zh-TW': 'chinois (traditionnel)',
    vi: 'vietnamien',
    id: 'indonésien',
  },
  it: {
    en: 'inglese',
    ar: 'arabo',
    es: 'spagnolo',
    'pt-BR': 'portoghese (Brasile)',
    fr: 'francese',
    it: 'Italiano',
    ko: 'coreano',
    de: 'tedesco',
    ja: 'giapponese',
    hi: 'hindi',
    ru: 'russo',
    zh: 'cinese',
    'zh-TW': 'cinese (tradizionale)',
    vi: 'vietnamita',
    id: 'indonesiano',
  },
  ko: {
    en: '영어',
    ar: '아랍어',
    es: '스페인어',
    'pt-BR': '포르투갈어(브라질)',
    fr: '프랑스어',
    it: '이탈리아어',
    ko: '한국어',
    de: '독일어',
    ja: '일본어',
    hi: '힌디어',
    ru: '러시아어',
    zh: '중국어',
    'zh-TW': '중국어(번체)',
    vi: '베트남어',
    id: '인도네시아어',
  },
  de: {
    en: 'Englisch',
    ar: 'Arabisch',
    es: 'Spanisch',
    'pt-BR': 'Portugiesisch (Brasilien)',
    fr: 'Französisch',
    it: 'Italienisch',
    ko: 'Koreanisch',
    de: 'Deutsch',
    ja: 'Japanisch',
    hi: 'Hindi',
    ru: 'Russisch',
    zh: 'Chinesisch',
    'zh-TW': 'Chinesisch (Traditionell)',
    vi: 'Vietnamesisch',
    id: 'Indonesisch',
  },
  ja: {
    en: '英語',
    ar: 'アラビア語',
    es: 'スペイン語',
    'pt-BR': 'ポルトガル語 (ブラジル)',
    fr: 'フランス語',
    it: 'イタリア語',
    ko: '韓国語',
    de: 'ドイツ語',
    ja: '日本語',
    hi: 'ヒンディー語',
    ru: 'ロシア語',
    zh: '中国語',
    'zh-TW': '中国語 (繁体字)',
    vi: 'ベトナム語',
    id: 'インドネシア語',
  },
  hi: {
    en: 'अंग्रेज़ी',
    ar: 'अरबी',
    es: 'स्पेनिश',
    'pt-BR': 'पुर्तगाली (ब्राज़ील)',
    fr: 'फ़्रेंच',
    it: 'इतालवी',
    ko: 'कोरियाई',
    de: 'जर्मन',
    ja: 'जापानी',
    hi: 'हिन्दी',
    ru: 'रूसी',
    zh: 'चीनी',
    'zh-TW': 'चीनी (पारंपरिक)',
    vi: 'वियतनामी',
    id: 'इंडोनेशियाई',
  },
  ru: {
    en: 'английский',
    ar: 'арабский',
    es: 'испанский',
    'pt-BR': 'португальский (Бразилия)',
    fr: 'французский',
    it: 'итальянский',
    ko: 'корейский',
    de: 'немецкий',
    ja: 'японский',
    hi: 'хинди',
    ru: 'Русский',
    zh: 'китайский',
    'zh-TW': 'китайский (традиционное письмо)',
    vi: 'вьетнамский',
    id: 'индонезийский',
  },
  zh: {
    en: '英语',
    ar: '阿拉伯语',
    es: '西班牙语',
    'pt-BR': '葡萄牙语（巴西）',
    fr: '法语',
    it: '意大利语',
    ko: '韩语',
    de: '德语',
    ja: '日语',
    hi: '印地语',
    ru: '俄语',
    zh: '中文',
    'zh-TW': '中文（繁体）',
    vi: '越南语',
    id: '印度尼西亚语',
  },
  'zh-TW': {
    en: '英文',
    ar: '阿拉伯文',
    es: '西班牙文',
    'pt-BR': '葡萄牙文（巴西）',
    fr: '法文',
    it: '義大利文',
    ko: '韓文',
    de: '德文',
    ja: '日文',
    hi: '印地文',
    ru: '俄文',
    zh: '中文',
    'zh-TW': '繁體中文',
    vi: '越南文',
    id: '印尼文',
  },
  vi: {
    en: 'Tiếng Anh',
    ar: 'Tiếng Ả Rập',
    es: 'Tiếng Tây Ban Nha',
    'pt-BR': 'Tiếng Bồ Đào Nha (Brazil)',
    fr: 'Tiếng Pháp',
    it: 'Tiếng Italy',
    ko: 'Tiếng Hàn',
    de: 'Tiếng Đức',
    ja: 'Tiếng Nhật',
    hi: 'Tiếng Hindi',
    ru: 'Tiếng Nga',
    zh: 'Tiếng Trung',
    'zh-TW': 'Tiếng Trung (Phồn thể)',
    vi: 'Tiếng Việt',
    id: 'Tiếng Indonesia',
  },
  id: {
    en: 'Inggris',
    ar: 'Arab',
    es: 'Spanyol',
    'pt-BR': 'Portugis (Brasil)',
    fr: 'Prancis',
    it: 'Italia',
    ko: 'Korea',
    de: 'Jerman',
    ja: 'Jepang',
    hi: 'Hindi',
    ru: 'Rusia',
    zh: 'Tionghoa',
    'zh-TW': 'Tionghoa (Tradisional)',
    vi: 'Vietnam',
    id: 'Bahasa Indonesia',
  },
} satisfies Record<SupportedLocale, Record<SupportedLocale, string>>;
